export const translations = {
  en: {
    common_system: 'System',
    common_light: 'Light',
    common_dark: 'Dark',
    common_default: 'Default',
    common_ocean: 'Ocean',
    common_forest: 'Forest',
    common_sunset: 'Sunset',
    common_language_en: 'English',
    common_language_ur: 'Urdu',
    common_logout: 'Logout',
    common_search: 'Search',
    common_loading: 'Loading...',
    common_na: 'N/A',

    header_sale_banner: '11-11 SALE IS LIVE NOW /---',
    header_contact_banner: 'For any queries, Contact us on whatsapp +92 331 7726261',
    header_logo: 'Logo',
    header_home: 'Home',
    header_catalog: 'Catalog',
    header_contact: 'Contact',
    header_admin_panel: 'Admin Panel',
    header_my_account: 'My Account',
    header_my_orders: 'My Orders',
    header_my_favourites: 'My Favourites',
    header_sign_in: 'Sign In',
    header_my_cart: 'My Cart',
    header_sign_in_cart: 'Sign in to see your cart.',
    header_sign_in_continue: 'Sign In to Continue',
    header_go_checkout: 'Go to Cart & Checkout',
    header_cart_empty: 'Your cart is empty.',
    header_total: 'Total',
    notifications_title: 'Notifications',
    notifications_mark_all_read: 'Mark all read',
    notifications_empty: 'No notifications yet.',
    notifications_new: 'New',
    notifications_read: 'Read',
    notifications_view_all: 'View all notifications',
    notifications_loading: 'Loading notifications...',
    notifications_mark_read: 'Mark read',

    footer_quick_links: 'Quick Links',
    footer_terms: 'Terms and Conditions',
    footer_refund: 'Refund Policy',
    footer_privacy: 'Privacy Policy',
    footer_shipping: 'Shipping Policy',
    footer_contact_address: 'Contact and Address',
    footer_mission: 'Our Mission',
    footer_mission_text: 'Here at Karar we are creating a future that welcomes all and wastes nothing.',
    footer_contact_us: 'Contact Us',
    footer_contact_text: 'For any queries, we are here to assist you on Instagram @arkab.shop and on live chat',

    admin_panel: 'Admin Panel',
    admin_go_customer: 'Go To Customer Store',
    admin_sidebar_home: 'Home',
    admin_sidebar_orders: 'Orders',
    admin_sidebar_carts: 'Carts',
    admin_sidebar_products: 'Products',
    admin_sidebar_delivery_boys: 'Delivery Boys',
    admin_sidebar_promotions: 'Promotions',
    admin_sidebar_announcements: 'Announcements',
    admin_sidebar_returns: 'Returns',
    admin_sidebar_logs: 'Logs',
    admin_sidebar_reviews: 'Reviews',
    admin_sidebar_categories: 'Categories',
    admin_sidebar_customers: 'Customers',
    admin_sidebar_admin_users: 'Admin Users',
    admin_sidebar_registered_users: 'Registered Users',
    admin_sidebar_settings: 'Settings',

    login_title: 'Login',
    login_admin_title: 'Admin Login',
    login_delivery_title: 'Delivery Login',
    login_username_email: 'Username or Email',
    login_password: 'Password',
    login_sign_in: 'Sign in',
    login_sign_in_admin: 'Sign in as Admin',
    login_sign_in_delivery: 'Sign in as Delivery Boy',
    login_create_account: 'Create account',
    login_admin_entry: 'Admin login',
    login_delivery_entry: 'Delivery login',
    login_back_customer: 'Back to customer login',
    login_forgot_password: 'Forgot your password?',
    login_all_fields_required: 'All fields are required.',
    login_failed: 'Login failed. Please try again.',

    delivery_dashboard: 'Delivery Dashboard',
    delivery_assigned_orders: 'Assigned Orders',
    delivery_no_orders: 'No orders are currently assigned to you.',
    delivery_update_status: 'Update Delivery Status',
    delivery_select_order: 'Select an order',
    delivery_status: 'Status',
    delivery_note: 'Delivery Note (optional)',
    delivery_failure_reason: 'Failure Reason',
    delivery_proof_url: 'Proof of Delivery URL',
    delivery_update_btn: 'Update Status',

    logs_title: 'Operation Logs',
    logs_search_placeholder: 'Search by order, actor, status, note',
    logs_time: 'Time',
    logs_order: 'Order',
    logs_customer: 'Customer',
    logs_transition: 'Transition',
    logs_actor: 'Actor',
    logs_note: 'Note',
    logs_no_data: 'No logs available',
    logs_to: 'to',
    logs_start: 'start',
    logs_system: 'system',
  },
  ur: {
    common_system: 'سسٹم',
    common_light: 'لائٹ',
    common_dark: 'ڈارک',
    common_default: 'ڈیفالٹ',
    common_ocean: 'اوشن',
    common_forest: 'فاریسٹ',
    common_sunset: 'سن سیٹ',
    common_language_en: 'انگریزی',
    common_language_ur: 'اردو',
    common_logout: 'لاگ آؤٹ',
    common_search: 'تلاش',
    common_loading: 'لوڈ ہو رہا ہے...',
    common_na: 'دستیاب نہیں',

    header_sale_banner: '11-11 سیل اب لائیو ہے /---',
    header_contact_banner: 'کسی بھی سوال کے لیے واٹس ایپ +92 331 7726261 پر رابطہ کریں',
    header_logo: 'لوگو',
    header_home: 'ہوم',
    header_catalog: 'کیٹلاگ',
    header_contact: 'رابطہ',
    header_admin_panel: 'ایڈمن پینل',
    header_my_account: 'میرا اکاؤنٹ',
    header_my_orders: 'میرے آرڈرز',
    header_my_favourites: 'میرے پسندیدہ',
    header_sign_in: 'سائن ان',
    header_my_cart: 'میرا کارٹ',
    header_sign_in_cart: 'کارٹ دیکھنے کے لیے سائن ان کریں۔',
    header_sign_in_continue: 'جاری رکھنے کے لیے سائن ان',
    header_go_checkout: 'کارٹ اور چیک آؤٹ',
    header_cart_empty: 'آپ کا کارٹ خالی ہے۔',
    header_total: 'کل',
    notifications_title: 'اطلاعات',
    notifications_mark_all_read: 'سب کو پڑھا ہوا نشان زد کریں',
    notifications_empty: 'ابھی کوئی اطلاع نہیں ہے۔',
    notifications_new: 'نئی',
    notifications_read: 'پڑھی ہوئی',
    notifications_view_all: 'تمام اطلاعات دیکھیں',
    notifications_loading: 'اطلاعات لوڈ ہو رہی ہیں...',
    notifications_mark_read: 'پڑھا ہوا نشان زد کریں',

    footer_quick_links: 'اہم لنکس',
    footer_terms: 'شرائط و ضوابط',
    footer_refund: 'ریفنڈ پالیسی',
    footer_privacy: 'پرائیویسی پالیسی',
    footer_shipping: 'شپنگ پالیسی',
    footer_contact_address: 'رابطہ اور پتہ',
    footer_mission: 'ہمارا مشن',
    footer_mission_text: 'ہم ایک ایسا مستقبل بنا رہے ہیں جو سب کو خوش آمدید کہے اور کچھ ضائع نہ ہو۔',
    footer_contact_us: 'ہم سے رابطہ کریں',
    footer_contact_text: 'سوالات کے لیے انسٹاگرام @arkab.shop اور لائیو چیٹ پر دستیاب ہیں۔',

    admin_panel: 'ایڈمن پینل',
    admin_go_customer: 'کسٹمر سائیڈ پر جائیں',
    admin_sidebar_home: 'ہوم',
    admin_sidebar_orders: 'آرڈرز',
    admin_sidebar_carts: 'کارٹس',
    admin_sidebar_products: 'پروڈکٹس',
    admin_sidebar_delivery_boys: 'ڈیلیوری بوائز',
    admin_sidebar_promotions: 'پروموشنز',
    admin_sidebar_announcements: 'اعلانات',
    admin_sidebar_returns: 'واپسی درخواستیں',
    admin_sidebar_logs: 'لاگز',
    admin_sidebar_reviews: 'ریویوز',
    admin_sidebar_categories: 'کیٹیگریز',
    admin_sidebar_customers: 'کسٹمرز',
    admin_sidebar_admin_users: 'ایڈمن یوزرز',
    admin_sidebar_registered_users: 'رجسٹرڈ یوزرز',
    admin_sidebar_settings: 'سیٹنگز',

    login_title: 'لاگ اِن',
    login_admin_title: 'ایڈمن لاگ اِن',
    login_delivery_title: 'ڈیلیوری لاگ اِن',
    login_username_email: 'یوزرنیم یا ای میل',
    login_password: 'پاس ورڈ',
    login_sign_in: 'سائن اِن',
    login_sign_in_admin: 'ایڈمن کے طور پر سائن اِن',
    login_sign_in_delivery: 'ڈیلیوری کے طور پر سائن اِن',
    login_create_account: 'اکاؤنٹ بنائیں',
    login_admin_entry: 'ایڈمن لاگ اِن',
    login_delivery_entry: 'ڈیلیوری لاگ اِن',
    login_back_customer: 'کسٹمر لاگ اِن پر واپس جائیں',
    login_forgot_password: 'پاس ورڈ بھول گئے؟',
    login_all_fields_required: 'تمام فیلڈز لازمی ہیں۔',
    login_failed: 'لاگ اِن ناکام۔ دوبارہ کوشش کریں۔',

    delivery_dashboard: 'ڈیلیوری ڈیش بورڈ',
    delivery_assigned_orders: 'اسائن شدہ آرڈرز',
    delivery_no_orders: 'فی الحال آپ کو کوئی آرڈر اسائن نہیں۔',
    delivery_update_status: 'ڈیلیوری اسٹیٹس اپڈیٹ',
    delivery_select_order: 'آرڈر منتخب کریں',
    delivery_status: 'اسٹیٹس',
    delivery_note: 'ڈیلیوری نوٹ (اختیاری)',
    delivery_failure_reason: 'ناکامی کی وجہ',
    delivery_proof_url: 'پروف آف ڈیلیوری لنک',
    delivery_update_btn: 'اسٹیٹس اپڈیٹ کریں',

    logs_title: 'آپریشن لاگز',
    logs_search_placeholder: 'آرڈر، ایکٹر، اسٹیٹس یا نوٹ تلاش کریں',
    logs_time: 'وقت',
    logs_order: 'آرڈر',
    logs_customer: 'کسٹمر',
    logs_transition: 'ٹرانزیشن',
    logs_actor: 'ایکٹر',
    logs_note: 'نوٹ',
    logs_no_data: 'کوئی لاگز دستیاب نہیں',
    logs_to: 'سے',
    logs_start: 'آغاز',
    logs_system: 'سسٹم',
  },
} as const;

export type TranslationKey = keyof typeof translations.en;
export type AppLanguage = keyof typeof translations;
